var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _g4, _path6, _path7, _g5, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductLogoWithBlur2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 48,
    viewBox: "0 0 140 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 48,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_3289)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_78_3289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 96,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.563 11.502H22.4629V36.565H117.563V11.502Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_78_3289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0986 31.9814H32.3652L34.7319 36.5992H112.432L114.799 31.9814H87.9319C87.6652 33.6211 86.2319 34.8926 84.5319 34.8926C82.7986 34.8592 81.3652 33.6211 81.0986 31.9814Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_78_3289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 96,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.563 11.502H22.4629V36.565H117.563V11.502Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_78_3289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3953 22.0104L87.5286 12.8418H81.4286L77.162 18.0284L73.162 12.8753H69.6286V16.5895L73.9953 22.0104L66.6953 31.179H73.162L77.162 26.0258L81.062 31.0117C81.262 29.2717 82.7286 27.8997 84.4953 27.8997C84.6953 27.8997 84.8953 27.9332 85.0953 27.9666L80.3953 22.0104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_78_3289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 96,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.563 11.502H22.4629V36.565H117.563V11.502Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_78_3289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4969 28.7021C85.9969 28.7021 87.1969 29.9068 87.1969 31.4126C87.1969 32.9184 85.9969 34.0895 84.4969 34.0895C82.9969 34.0895 81.7969 32.8849 81.7969 31.3791C81.7969 29.8733 83.0302 28.7021 84.4969 28.7021Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0651 24.7198H96.8651L94.4318 21.2063L92.0651 24.7198ZM84.8984 26.3929L94.4318 12.8408L107.265 31.178H101.298L99.3318 28.3337H89.6651L88.1984 30.5757L84.8984 26.3929Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_78_3289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 96,
    height: 26
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.563 11.502H22.4629V36.565H117.563V11.502Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_78_3289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.527 13.5097H114.161V14.4466H114.627C114.861 14.4466 115.061 14.2124 115.061 13.9781C115.061 13.677 114.827 13.5097 114.527 13.5097ZM115.061 15.0155L115.794 16.1866H114.994L114.127 14.8816V16.1866H113.461V12.8404H114.527C115.161 12.8404 115.727 13.3089 115.727 13.9447V14.0451C115.727 14.5135 115.461 14.8482 115.061 15.0155ZM114.561 12.1377C113.261 12.1377 112.194 13.2085 112.194 14.547C112.194 15.852 113.261 16.9228 114.561 16.9228C115.861 16.9228 116.927 15.852 116.927 14.547C116.961 13.2085 115.861 12.1377 114.561 12.1377ZM116.694 12.372C117.294 12.9743 117.561 13.677 117.561 14.5135C117.561 15.3501 117.261 16.0528 116.694 16.6551C116.094 17.2574 115.394 17.5251 114.561 17.5251C113.727 17.5251 113.027 17.224 112.427 16.6551C111.827 16.0528 111.561 15.3501 111.561 14.5135C111.561 13.677 111.861 12.9743 112.427 12.372C112.994 11.7696 113.727 11.502 114.561 11.502C115.394 11.502 116.127 11.8031 116.694 12.372Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.268 12.8408V22.6452L108.201 31.178H115.201L117.601 26.5603H107.868V12.8408H102.268Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_78_3289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 96,
    height: 26
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.563 11.502H22.4629V36.565H117.563V11.502Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_78_3289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8629 22.4119V12.8418H63.6296V22.8804C63.6296 24.9551 61.9629 26.6282 59.8962 26.6282C57.8296 26.6282 56.1629 24.9551 56.1629 22.8804V12.8418H52.8962L50.9629 16.623V22.4119C50.9629 27.3643 54.9962 31.3798 59.9296 31.3798C64.8296 31.3798 68.8296 27.3643 68.8629 22.4119Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2629 12.2041L32.6296 20.9377L28.7962 12.8399H22.4629L32.0629 31.4113L37.2962 22.845L42.4962 31.4113L52.0629 12.8399H45.7296L41.9296 20.9377L37.2629 12.2041Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_3289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 26,
    fill: "white",
    transform: "translate(22 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLogoWithBlur2);
export default __webpack_public_path__ + "static/media/product-logo-with-blur-2.93b46ab6227e54c4b25a5c215786d4ce.svg";
export { ForwardRef as ReactComponent };